import './Filters.scss';
import classNames from 'classnames';
import { NestedOrganizationsSelector } from 'components/NestedOrganizationsSelector/NestedOrganizationsSelector';
import { useEffect, useState } from 'react';
import { isTablet } from 'services/mobile';

const SCROLL_THRESHOLD = 0.2;

const getStickyStyles = ({
  clientHeight,
  isTabletDevice,
  scrollHeight,
  scrollPosition,
  scrollProgress,
}: {
  clientHeight: number,
  isTabletDevice: boolean,
  scrollHeight: number,
  scrollPosition: number,
  scrollProgress: number,
}) => {
  if (isTabletDevice) {
    return {};
  }

  return {
    backgroundColor: scrollPosition > SCROLL_THRESHOLD
      ? `rgba(255, 255, 255, ${scrollPosition * 4})`
      : 'rgba(255, 255, 255, 0)',

    boxShadow:
          clientHeight === scrollHeight || scrollPosition < SCROLL_THRESHOLD
            ? '0 0.25em 0.5em 0 rgba(0, 0, 0, 0)'
            : '0 0.25em 0.5em 0 rgba(0, 0, 0, 0.06), 0 1px 2px 0 rgba(0, 0, 0, 0.04), 0 0.375em 2.5em 0 rgba(38, 50, 56, 0.05)',

    height: `${5 - scrollProgress}rem`,
  };
};

const Filters = () => {
  // tracking scroll position and calculating scroll progress, code tracks how far the user has scrolled for optimizing animation
  const [scrollProgress, setScrollProgress] = useState(0);
  const clientHeight = document.querySelector('.app')?.clientHeight as number;
  const scrollHeight = document.querySelector('.app')?.scrollHeight as number;
  const scrollTop = document.querySelector('.app')?.scrollTop as number;
  const scrollPosition = scrollTop / (scrollHeight - clientHeight);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = document.querySelector('.app')?.scrollTop;
      const maxScroll = 100;
      if (scrollY || scrollY === 0 && clientHeight === scrollHeight) {
        const progress = Math.min(scrollY / maxScroll, 1);
        setScrollProgress(progress);
      }
    };

    window.addEventListener('DOMMouseScroll', handleScroll);
    window.onwheel = handleScroll;
    window.ontouchmove = handleScroll;
    document.onkeydown = handleScroll;

    return () => window.removeEventListener('DOMMouseScroll', handleScroll);
  }, []);

  return (
    <div
      className={classNames('sticky z-[11] justify-end filters top-0 min-w-[100vw] p-0 ms:px-[1rem] xl:!px-[4.5rem] bg-white-999 flex flex-col w-full items-center ms:bg-black-150')}
      style={getStickyStyles({
        clientHeight,
        isTabletDevice: isTablet(),
        scrollHeight,
        scrollPosition,
        scrollProgress,
      })}
    >
      <div className='flex w-full max-w-[90rem] items-center justify-between'>
        <NestedOrganizationsSelector scrollProgress={scrollPosition} />
      </div>
    </div>
  );
};

export default Filters;
